import React from "react";
import { Link } from "react-router-dom";
import "./ContactButton.css";

const composeClassName = (...classes) => classes.filter(Boolean).join(" ");

const ContactButton = ({
  children,
  to,
  href,
  external = false,
  onClick,
  className = "",
  variant = "primary",
  type = "button",
  disabled = false,
  ...rest
}) => {
  const sharedClassName = composeClassName("contact-btn", variant, disabled && "is-disabled", className);

  if (to) {
    const handleClick = (event) => {
      if (disabled) { event.preventDefault(); return; }
      if (typeof onClick === "function") onClick(event);
    };
    return (
      <Link
        to={to}
        className={sharedClassName}
        aria-disabled={disabled || undefined}
        tabIndex={disabled ? -1 : undefined}
        onClick={handleClick}
        {...rest}
      >
        {children}
      </Link>
    );
  }

  if (href) {
    const handleClick = (event) => {
      if (disabled) { event.preventDefault(); return; }
      if (typeof onClick === "function") onClick(event);
    };
    return (
      <a
        href={href}
        className={sharedClassName}
        target={external ? "_blank" : undefined}
        rel={external ? "noreferrer" : undefined}
        aria-disabled={disabled || undefined}
        tabIndex={disabled ? -1 : undefined}
        onClick={handleClick}
        {...rest}
      >
        {children}
      </a>
    );
  }

  return (
    <button type={type} className={sharedClassName} onClick={onClick} disabled={disabled} {...rest}>
      {children}
    </button>
  );
};

export default ContactButton;
